if (!customElements.get('collapsible-tabs')) {
  customElements.define(
    'collapsible-tabs',
    class CollapsibleTabs extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.detailsElements = this.querySelectorAll('.accordion-details');
        this.colorScheme = this.dataset.colorScheme;

        this.detailsElements.length > 0 &&
          this.detailsElements.forEach((details) => {
            details.open ? this.handleOpen(details) : this.handleClose(details);
            details.addEventListener('toggle', this.onToggle.bind(this));
          });
      }

      onToggle(event) {
        const activeDetails = event.target;
        if (activeDetails.open) {
          this.handleOpen(activeDetails);
        } else {
          this.handleClose(activeDetails);
        }
      }

      handleOpen(details) {
        const parent = details.closest('.accordion-item');
        parent.classList.contains('accordion-card') && parent.classList.add(this.colorScheme);
      }

      handleClose(details) {
        const parent = details.closest('.accordion-item');
        parent.classList.contains('accordion-card') && parent.classList.remove(this.colorScheme);
      }
    }
  );
}
// ===== Auto Slideshow: Click to advance =====
(function () {
  const imagesWrap = document.querySelector('.collection-tabs__images');
  if (!imagesWrap) return;

  const slides = Array.from(imagesWrap.querySelectorAll('.collection-tabs__image'));
  if (slides.length < 2) return;

  let current = 0;
  let intervalId = null;
  const DURATION = 4000; // 1枚あたりの表示時間（ms）

  function goTo(index) {
    slides[current].style.animationPlayState = 'paused';
    slides[current].style.opacity = '0';
    current = (index + slides.length) % slides.length;
    slides[current].style.animationPlayState = 'paused';
    slides[current].style.opacity = '1';
  }

  function startAuto() {
    clearInterval(intervalId);
    intervalId = setInterval(() => {
      goTo(current + 1);
    }, DURATION);
  }

  // 初期化：CSSアニメーションをJS制御に切り替え
  slides.forEach((slide, i) => {
    slide.style.animation = 'none';
    slide.style.opacity = i === 0 ? '1' : '0';
  });
  current = 0;

  // クリックで次へ
  imagesWrap.addEventListener('click', (e) => {
    e.preventDefault();
    goTo(current + 1);
    startAuto(); // クリック後もオートリセット
  });

  startAuto();
})();
